import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';

import { AppConfig } from '../config/app.config';
import { IReturnObject } from '../shared/return-object.model';
import { DistributionUnitBE } from './shared/distribution-unit.model';

@Injectable()
export class DistributionUnitService {
    constructor(private config: AppConfig, private http: Http) { }

    private apiUrl: string = this.config.get('apiUrl') + 'DistributionUnit';
    private apiNotImplementedUrl: string = this.config.get('apiUrl') + 'NotImplementedYet'; //TEMP
    
    getDistrUnitList(searchTerm: string): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetDistributionUnitList/?searchTerm=${searchTerm}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    getDistrUnit(id: number): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetDistributionUnit/?id=${id}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    deleteDistrUnit(id: number): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/DeleteDistributionUnit/?id=${id}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    GetPreviewPdfforDU(id: number,MHNo: string): Observable<any> {
        return this.http.get(`${this.apiUrl}/GetPreviewPdfforDU/?duId=${id}&mhNo=${MHNo}`);       
    }

    saveDistributionUnit(distrUnit: DistributionUnitBE): Observable<IReturnObject> {
        let headers: Headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/json');
        let body = JSON.stringify(distrUnit);
        let options = new RequestOptions({ headers: headers });

        return this.http.post(`${this.apiUrl}/SaveDistributionUnit`, body, options)
            .map((response: Response) => <IReturnObject>response.json());
    }

    loadAdditionalDistUnitInfo(duId: number) {
        return this.http.get(`${this.apiUrl}/GetAdditionalDistUnitInfo/?id=${duId}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    loadDUComposition(duId: number) {
        return this.http.get(`${this.apiUrl}/GetDUComposition/?id=${duId}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

 

}


// WEBPACK FOOTER //
// C:/Users/SHR6M3/Development/PackITWebGui/src/app/distribution-unit/distribution-unit.service.ts